import React, { useState } from "react";
import styled from "styled-components";
import { Layout } from "./ui/Layout";
import { mediaQuery } from "react-styled-mediaquery";
import { TablePriceMobile } from "./TablePriceMobile";
import { TablePrice } from "./TablePrice";
import { type, row } from "../lib/data/plans";
import { Media } from "../lib/media";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { Dropdown } from "./ui/Dropdown";

export interface TablePriceType {
  key: string;
  title: string;
  dossier: string;
  prixDossier: string;
  prixMois: string;
}

const SectionPriceTitle = styled.div`
  text-align: center;
  width: 70%;
  margin: 0 auto 80px auto;

  ${mediaQuery("<=", "tablet")`
    width: 100%;
    margin-bottom: 30px;
  `}
`;

export const SectionPrice = () => {
  const [valueIndex, setValueIndex] = useState(1);
  function changeValueSelect(e: React.ChangeEvent<HTMLSelectElement>) {
    setValueIndex(parseInt(e.currentTarget.value, 10));
  }
  return (
    <>
      <Layout id="price">
        <SectionPriceTitle>
          <Title htmlLevel={2} theme="titleBodyStyle">
            Une totale maîtrise de votre budget
          </Title>

          <Paragraph>
            Utilisation illimité de tablettes, sauvegarde & sécurisation des
            données, assistance et formation, Street Funders est disponible via
            une licence unique qui permet de facilement limiter le budget tout
            en bénéficiant d’une solution personnalisée, innovante et évolutive.
          </Paragraph>
        </SectionPriceTitle>

        <Media when={">768"}>
          <TablePrice type={type} rows={row} />
        </Media>

        <Media when={"<=768"}>
          <Dropdown
            items={type}
            onRequestChange={changeValueSelect}
            selectedItem={valueIndex}
          />
          <TablePriceMobile mobileType={type[valueIndex]} mobileRows={row} />
        </Media>
      </Layout>
    </>
  );
};
